export enum UnitDetailsComponentForm {
  FINISH = 'finish',
  DESCRIPTION = 'description',
  RENT = 'rent',
  OLDRENT = 'oldRent',
  MARKETRENT = 'marketRent',
  ADVERTISEDRENT = 'advertisedRent',
}
